import { ColumnDef } from '@tanstack/react-table';

import { Checkbox } from '../../checkbox';

export const COLUMN_CHECKBOX: ColumnDef<any, any>[] = [
  {
    id: 'columnSelectionCheckbox',
    enableHiding: false,
    enableSorting: false,
    header: ({ table }) => (
      <Checkbox
        aria-label="seleccionar todos los registros de la página actual"
        checked={
          table.getIsAllPageRowsSelected() || (table.getIsSomePageRowsSelected() && 'indeterminate')
        }
        className="mx-4"
        size="md"
        onCheckedChange={(value) => table.toggleAllPageRowsSelected(!!value)}
      />
    ),
    cell: ({ row }) => (
      <Checkbox
        aria-label="seleccionar registro"
        checked={row.getIsSelected()}
        size="md"
        onCheckedChange={(value) => row.toggleSelected(!!value)}
      />
    ),
  },
];
